import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

const Select = React.forwardRef(({ className, style, wrapperStyle, children, onFocus, onBlur, ...props }, ref) => {
  const [focused, setFocused] = React.useState(false);

  return (
    <div style={{ position: "relative", width: "100%", ...wrapperStyle }}>
      <select
        ref={ref}
        className={cn(
          "tw-flex tw-h-11 tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-border-white/10 tw-bg-white/[0.03] tw-px-4 tw-py-1 tw-pr-9 tw-text-[14px] tw-text-white tw-transition-colors disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
          className
        )}
        style={{
          height: 44,
          width: "100%",
          padding: "0 36px 0 16px",
          borderRadius: 12,
          background: "rgba(255,255,255,0.035)",
          border: `1px solid ${focused ? "rgba(0,173,181,0.5)" : "rgba(255,255,255,0.12)"}`,
          boxShadow: focused
            ? "inset 0 1px 2px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,173,181,0.18)"
            : "inset 0 1px 2px rgba(0,0,0,0.15)",
          outline: "none",
          color: "#fff",
          fontSize: 14,
          appearance: "none",
          cursor: "pointer",
          fontFamily: "inherit",
          transition: "border-color 0.12s ease, box-shadow 0.12s ease",
          boxSizing: "border-box",
          ...style,
        }}
        onFocus={(e) => { setFocused(true); onFocus?.(e); }}
        onBlur={(e) => { setFocused(false); onBlur?.(e); }}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        size={15}
        style={{
          position: "absolute",
          right: 12,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#8b9296",
          pointerEvents: "none",
        }}
      />
    </div>
  );
});
Select.displayName = "Select";

const SelectOption = ({ value, children, ...props }) => (
  <option
    value={value}
    style={{ background: "#1e1e1e", color: "#fff" }}
    {...props}
  >
    {children}
  </option>
);

export { Select, SelectOption };
